import React from 'react'
import { Box } from '@mui/material'
import { muiGrey } from 'src/style/muiTheme'
import { StateObj } from 'src/types'
const cellColor = (targetState: StateObj) => (targetState.value === 'unselected' ? 'red' : muiGrey)

type Props = {
  isDisplay: boolean
  index: number
  targetState: StateObj
  header?: string
  item?: string
}
export const AdditionalEmbroideryConfirm: React.FC<Props> = ({ isDisplay, index, header, targetState, item }) => {
  if (!isDisplay) return <></>
  return (
    <Box mt={header?.length ? 2 : 0}>
      {header && (
        <Box fontWeight="bold" fontSize="16px">
          {header}
        </Box>
      )}
      <Box ml={1} key={targetState.value}>
        {`(${index}) ${item ? item + ':' : ''}`}
        <Box component="span" color={cellColor(targetState)} fontWeight={'bold'}>{`${targetState.label}`}</Box>
      </Box>
    </Box>
  )
}
